const PadlockRollDirectionEnum = Object.freeze({
    INCREMENT: 1,
    DECREMENT: -1
  });
  
  export default PadlockRollDirectionEnum;